export default __webpack_public_path__ + "static/media/error.c1bcc8fd.svg";